export default __webpack_public_path__ + "static/media/iStock-1371728740-0.923567fd.png";